import app from 'flarum/common/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Modal de confirmação compartilhado. Substitui o nativo `window.confirm`,
 * que quebra o estilo do admin e não suporta tradução nem variantes danger.
 *
 * Uso:
 *   app.modal.show(ConfirmModal, {
 *     title: 'Excluir cupom',
 *     message: 'Esta ação não pode ser desfeita.',
 *     danger: true,
 *     onConfirm: () => doDelete(),
 *   });
 */
export default class ConfirmModal extends Modal {
  className() {
    return 'Modal--small MarketplaceConfirmModal';
  }
  title() {
    return this.attrs.title;
  }

  /**
   * Renderiza body + footer juntos. O Modal base do Flarum não expõe slot
   * de footer, então emitimos os botões dentro do mesmo bloco do body.
   */
  content() {
    const danger = !!this.attrs.danger;
    const confirmLabel = this.attrs.confirmLabel || app.translator.trans('ramon-marketplace.lib.confirm.confirm') || 'Confirmar';
    const cancelLabel = this.attrs.cancelLabel || app.translator.trans('ramon-marketplace.lib.confirm.cancel') || 'Cancelar';
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "MarketplaceConfirmModal-message"
    }, this.attrs.message), m("div", {
      className: "MarketplaceConfirmModal-actions"
    }, m(Button, {
      className: "Button MpBtn MpBtn--ghost",
      onclick: () => this.hide()
    }, cancelLabel), this.attrs.secondaryLabel && m(Button, {
      className: "Button MpBtn MpBtn--outline",
      onclick: () => {
        this.attrs.onSecondary?.();
        this.hide();
      }
    }, this.attrs.secondaryLabel), m(Button, {
      className: 'Button MpBtn ' + (danger ? 'Button--danger MpBtn--danger' : 'Button--primary MpBtn--primary'),
      "data-confirm-action": "confirm",
      onclick: () => {
        this.attrs.onConfirm();
        this.hide();
      }
    }, confirmLabel)));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    requestAnimationFrame(() => {
      this.element.querySelector('[data-confirm-action="confirm"]')?.focus();
    });
  }
}
flarum.reg.add('ramon-marketplace', 'common/components/ConfirmModal', ConfirmModal);